import * as React from 'react'

const SvgImageIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 46 38" fill="none" {...props}>
    <path
      d="M2.674 30.594V7a5 5 0 015-5h31.31a5 5 0 015 5v23.594a5 5 0 01-5 5H7.675a5 5 0 01-5-5z"
      stroke="url(#ImageIcon_svg__paint0_linear)"
      strokeWidth={4}
    />
    <path
      d="M2.674 24.95l3.668-4.114a4 4 0 015.972 0l.823.923a4 4 0 005.84.14l8.482-8.64a4 4 0 015.79.085l10.736 11.607"
      stroke="url(#ImageIcon_svg__paint1_linear)"
      strokeWidth={4}
    />
    <defs>
      <linearGradient
        id="ImageIcon_svg__paint0_linear"
        x1={1}
        y1={0}
        x2={44}
        y2={33.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.646} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="ImageIcon_svg__paint1_linear"
        x1={3}
        y1={2}
        x2={44}
        y2={35}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.646} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgImageIcon
